import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class WaterBodyModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (WaterBodyModel._instance == null) WaterBodyModel._instance = new WaterBodyModel(authManager);
        return WaterBodyModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/water-bodies');

        this.entityName = 'geo-sections.WaterBody';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Water Body';
        this.setLabel = 'Water Bodies';

        this.browser = {
            name: 'default-geo-sections-waterbody-browser',
            moduleName: 'default-geo-sections-waterbody-browser',
            moduleTitle: 'Water Bodies',
            moduleStateSlotName: 'default-geo-sections-waterbody-browser',
        };

        this.editor = {
            name: 'default-geo-sections-waterbody-editor',
            moduleName: 'default-geo-sections-waterbody-editor',
            moduleTitle: 'Water Body',
            moduleStateSlotName: 'default-geo-sections-waterbody-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'geoSectionId',
                type: 'GeoSection',
                persistent: true,
                label: 'Geo Section',
                description: 'geoLayer odpovídá vždy jen jedné geoSection, n:1',
                inEditor: true,
            },
            {
                name: 'elevationTop',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationBottom',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationOfZeroDatumLevel',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Elevation Of Zero Datum Level',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLevelTop',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Vertical Level Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLevelBottom',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Vertical Level Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'thickness',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Thickness',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterBodyTypeId',
                type: 'WaterBodyType',
                persistent: true,
                label: 'Water Body Type',
                description: 'reference to particular water body type',
                inEditor: true,
            },
            {
                name: 'waterUnitWeightGamaW',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Water Unit Weight Gama W',
                inEditor: true,
            },
            {
                name: 'poissonCoefficientNiWater',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Poisson Coefficient Ni Water',
                inEditor: true,
            },
            {
                name: 'coefficientOfSidePressureKWater',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Coefficient Of Side Pressure K Water',
                inEditor: true,
            },
            {
                name: 'waterSurfaceStressCalcMethodId',
                type: 'WaterSurfaceStressCalculationMethod',
                persistent: true,
                label: 'Water Surface Stress Calc Method',
                inEditor: true,
            },
            {
                name: 'waterSurfaceStress',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Water Surface Stress',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterSurfaceStressGiven',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Water Surface Stress Given',
                inEditor: true,
            },
            {
                name: 'piezometricHeadCalcMethodId',
                type: 'PiezometricHeadCalculationMethod',
                persistent: true,
                label: 'Piezometric Head Calc Method',
                inEditor: true,
            },
            {
                name: 'piezometricHead',
                type: 'float',
                persistent: true,
                unit: 'm',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'piezometricHeadGiven',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Piezometric Head Given',
                inEditor: true,
            },
            {
                name: 'hasWaterBodyAboveRelation',
                type: 'bool',
                persistent: true,
                label: 'Has Water Body Above Relation',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'additionalStressTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Additional Stress Top',
                description: 'additional stress to stress of water body above if relation exists',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'hasWaterBodyBelowRelation',
                type: 'bool',
                persistent: true,
                label: 'Has Water Body Below Relation',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'additionalStressBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                description: 'additional stress to stress of water body below if relation exists',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterBodyAboveId',
                type: 'WaterBody',
                persistent: true,
                label: 'Water Body Above',
                description: 'meaning directly above',
            },
            {
                name: 'waterBodyBelowId',
                type: 'WaterBody',
                persistent: true,
                label: 'Water Body Below',
                description: 'meaning directly below',
            },
            {
                name: 'waterBodyPressureRelations',
                type: 'string',
                persistent: false,
                label: 'Water Body Pressure Relations',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'additionalStressEffectiveTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Additional Stress Effective Top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'additionalStressEffectiveBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Additional Stress Effective Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterBodyAbovePressureUzBottom',
                type: 'float',
                persistent: false,
                unit: 'kPa',
                label: 'Water Body Above Pressure Uz Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterBodyBelowPressureUzTop',
                type: 'float',
                persistent: false,
                unit: 'kPa',
                label: 'Water Body Below Pressure Uz Top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterBodyPressureIncreaseCoefKzInc',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterBodyPressureUzIncrease',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterBodyPressureUzTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Water Body Pressure Uz Top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterBodyPressureUzBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
